import { render } from "./MatrixDetail.vue?vue&type=template&id=359710fa&scoped=true"
import script from "./MatrixDetail.vue?vue&type=script&lang=js"
export * from "./MatrixDetail.vue?vue&type=script&lang=js"

import "./MatrixDetail.vue?vue&type=style&index=0&id=359710fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359710fa"]])

export default __exports__